export const listCampaignsExt = /* GraphQL */ `
  query ListCampaigns(
    $filter: ModelCampaignFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listCampaigns(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        userProfileId
        userProfile {
          id
          userId
          fullName
          age
          CompanyName
          OfficialEmailAddress
          Designation
          companyAddress
          companyPhoneNumber
          location
          createdAt
          updatedAt
          __typename
        }
        name
        startDate
        endDate
        budget
        estimatedCostOfCampaign
        approvedCostOfCampaign
        status
        paid
        adverts {
          items {
            id
          }
        }
        keywords
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const campaignAdvertInventoriesByCampaignIdExt = /* GraphQL */ `
  query CampaignAdvertInventoriesByCampaignId(
    $campaignId: ID!
    $sortDirection: ModelSortDirection
    $filter: ModelCampaignAdvertInventoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    campaignAdvertInventoriesByCampaignId(
      campaignId: $campaignId
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        advertId
        campaignId
        preRollIsSkippable
        preRollDuration
        midRollIsSkippable
        midRollDuration
        postRollIsSkippable
        postRollDuration
        requestStatus
        requestDeclineReason
        totalDuration
        totalCost
        createdAt
        updatedAt
        campaign {
          name
        }
        advert {
          id
          filePath
          title
          keywords
          createdAt
          status
        }

        __typename
      }
      nextToken
      __typename
    }
  }
`;

export const listManifestsExt = /* GraphQL */ `
  query ListManifests(
    $filter: ModelManifestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listManifests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        carrierId
        carrier {
          carrierName
        }
        adminApproved
        carrierApproved
        adminComments
        carrierComments
        manifestDate
        contentStartDate
        contentEndDate
        isActive
        isManifestDeployed
        DeploymentDate
        bucket
        date
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
